<template>
  <!-- Note: These modules are used in both the right rail, as well as the center content depending on the breakpoint  -->
  <div class="w-full">
    <div
      v-cloak
      class="*:py-6 lg:*:py-8 first:*:pt-0 last:*:pb-0 divide-y divide-ocean-100"
    >
      <vetster-why-vetster />
      <transition
        name="fade"
        appear
      >
        <vetster-meet-our-vet />
      </transition>
      <transition
        name="fade"
        appear
      >
        <vetster-related-post :posts="posts" />
      </transition>
    </div>
  </div>
</template>

<script>
import VetsterMeetOurVet from '@/brand-components/Content/VetsterMeetOurVet';
import VetsterRelatedPost from '@/brand-components/Content/VetsterRelatedPost';
import VetsterWhyVetster from '@/brand-components/Content/VetsterWhyVetster';

export default {
  name: 'VetsterEditorialModule',

  components: {
    VetsterMeetOurVet,
    VetsterRelatedPost,
    VetsterWhyVetster,
  },

  props: {
    posts: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
